module.exports = __webpack_public_path__ + "static/media/0010.7a71df23.png";